import { atom } from 'jotai'

export const GlobalManageColumns = atom<boolean>(false)
export const IsChangingProductQtyAtom = atom<boolean>(false)
export const PollingReportsAtom = atom<{ reportNumber?: string; reportId?: string }[]>([])
